"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientDto = void 0;
class ClientDto {
    constructor(params) {
        this.name = "";
        this.clientNumber = "";
        this.apiKey = "";
        this.lastPushMessage = "";
        this.createdAt = "";
        this.updatedAt = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.name = params.name;
        this.clientNumber = params.clientNumber;
        this.apiKey = params.apiKey;
        this.lastPushMessage = params.lastPushMessage;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
    }
}
exports.ClientDto = ClientDto;
//# sourceMappingURL=ClientDto.js.map